export default __webpack_public_path__ + "static/media/call.24076ffc.mp3";